import { Clock, Facebook, Mail, Phone, Youtube } from "lucide-react";

export default function DashboardFMPContactUs() {
  return (
    <div className='w-1/3 max-sm:w-full rounded-2xl shadow-md flex flex-col gap-4 text-white bg-ertc-secondary p-8'>
      <p className='font-bold text-3xl'>Contact Us</p>
      <div className='flex flex-row items-center gap-4'>
        <div className='bg-fmp-primary p-2'>
          <Mail size={24} />
        </div>
        <div className='flex flex-col'>
          <p className='font-bold'>Email</p>
          <a href='mailto:info@foundmoneyproject.com' className='text-blue-500 underline cursor-pointer'>info@foundmoneyproject.com</a>
        </div>
      </div>
      <div className='flex flex-row items-center gap-4'>
        <div className='bg-fmp-primary p-2'>
          <Phone size={24} />
        </div>
        <div className='flex flex-col'>
          <p className='font-bold'>Call</p>
          <a href='tel:+18669707770' className='text-blue-500 underline cursor-pointer'>(866) 970-7770</a>
        </div>
      </div>
      <div className='flex flex-row items-center gap-4'>
        <div className='bg-fmp-primary p-2'>
          <Clock size={24} />
        </div>
        <div className='flex flex-col'>
          <p className='font-bold'>Customer Support Hours</p>
          <div>
            <p>Monday - Friday</p>
            <p>9:00am EST - 7:00pm EST</p>
          </div>
        </div>
      </div>
      <div className='flex flex-row gap-4'>
        <div className='bg-fmp-primary p-2'>
          <Facebook size={24} />
        </div>
        <div className='bg-fmp-primary p-2'>
          <Youtube size={24} />
        </div>
      </div>
    </div>
  )
}